import * as PlasmicHost from '@plasmicapp/host';
import { PageParamsProvider, registerComponent, registerGlobalContext, registerTrait } from '@plasmicapp/host';
export { DataCtxReader, DataProvider, PageParamsProvider, PlasmicCanvasContext, PlasmicCanvasHost, repeatedElement, useDataEnv, usePlasmicCanvasContext, useSelector, useSelectors } from '@plasmicapp/host';
import * as PlasmicQuery from '@plasmicapp/query';
import { PlasmicQueryDataProvider, PlasmicPrepassContext } from '@plasmicapp/query';
export { usePlasmicQueryData } from '@plasmicapp/query';
import { getBundleSubset, Registry, PlasmicModulesFetcher, PlasmicTracker } from '@plasmicapp/loader-core';
import { getExternalIds, getActiveVariation } from '@plasmicapp/loader-splits';
import React__default, { useState, useCallback, useEffect, useRef, useMemo, createElement, memo, useContext, createContext } from 'react';
import ReactDOM from 'react-dom';
import * as jsxDevRuntime from 'react/jsx-dev-runtime';
import * as jsxRuntime from 'react/jsx-runtime';
import pascalcase from 'pascalcase';
import { isFragment } from 'react-is';
import prepass from 'react-ssr-prepass';
import ReactDOMServer from 'react-dom/server';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function getUsedComps(allComponents, entryCompIds) {
  var q = [].concat(entryCompIds);
  var seenIds = new Set(entryCompIds);
  var componentMetaById = new Map(allComponents.map(function (meta) {
    return [meta.id, meta];
  }));
  var usedComps = [];

  while (q.length > 0) {
    var _q$splice = q.splice(0, 1),
        id = _q$splice[0];

    var meta = componentMetaById.get(id);

    if (!meta) {
      continue;
    }

    usedComps.push(meta);
    meta.usedComponents.forEach(function (usedCompId) {
      if (!seenIds.has(usedCompId)) {
        seenIds.add(usedCompId);
        q.push(usedCompId);
      }
    });
  }

  return usedComps;
}

function prepComponentData(bundle) {
  for (var _len = arguments.length, compMetas = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    compMetas[_key - 1] = arguments[_key];
  }

  if (compMetas.length === 0) {
    return {
      entryCompMetas: bundle.components,
      bundle: bundle,
      remoteFontUrls: []
    };
  }

  var usedComps = getUsedComps(bundle.components, compMetas.map(function (compMeta) {
    return compMeta.id;
  }));
  var compPaths = usedComps.map(function (compMeta) {
    return compMeta.entry;
  });
  var subBundle = getBundleSubset.apply(void 0, [bundle, 'entrypoint.css'].concat(compPaths, ['root-provider.js'], bundle.projects.map(function (x) {
    return x.globalContextsProviderFileName;
  }).filter(function (x) {
    return !!x;
  }), bundle.components.filter(function (c) {
    return c.isGlobalContextProvider;
  }).map(function (c) {
    return c.entry;
  }), bundle.globalGroups.map(function (g) {
    return g.contextFile;
  })));
  var remoteFontUrls = [];
  subBundle.projects.forEach(function (p) {
    return remoteFontUrls.push.apply(remoteFontUrls, p.remoteFonts.map(function (f) {
      return f.url;
    }));
  });
  return {
    entryCompMetas: compMetas,
    bundle: subBundle,
    remoteFontUrls: remoteFontUrls
  };
}
function mergeBundles(target, from) {
  var _from$activeSplits$fi;

  var existingCompIds = new Set(target.components.map(function (c) {
    return c.id;
  }));
  var newCompMetas = from.components.filter(function (m) {
    return !existingCompIds.has(m.id);
  });

  if (newCompMetas.length > 0) {
    target = _extends({}, target, {
      components: [].concat(target.components, newCompMetas)
    });
  }

  var existingProjects = new Set(target.projects.map(function (p) {
    return p.id;
  }));
  var newProjects = from.projects.filter(function (p) {
    return !existingProjects.has(p.id);
  });

  if (newProjects.length > 0) {
    target = _extends({}, target, {
      projects: [].concat(target.projects, newProjects)
    });
  }

  var existingModules = {
    browser: new Set(target.modules.browser.map(function (m) {
      return m.fileName;
    })),
    server: new Set(target.modules.server.map(function (m) {
      return m.fileName;
    }))
  };
  var newModules = {
    browser: from.modules.browser.filter(function (m) {
      return !existingModules.browser.has(m.fileName);
    }),
    server: from.modules.server.filter(function (m) {
      return !existingModules.server.has(m.fileName);
    })
  };

  if (newModules.browser.length > 0 || newModules.server.length > 0) {
    target = _extends({}, target, {
      modules: {
        browser: [].concat(target.modules.browser, newModules.browser),
        server: [].concat(target.modules.server, newModules.server)
      }
    });
  }

  var existingGlobalIds = new Set(target.globalGroups.map(function (g) {
    return g.id;
  }));
  var newGlobals = from.globalGroups.filter(function (g) {
    return !existingGlobalIds.has(g.id);
  });

  if (newGlobals.length > 0) {
    target = _extends({}, target, {
      globalGroups: [].concat(target.globalGroups, newGlobals)
    });
  }

  var existingExternals = new Set(target.external);
  var newExternals = target.external.filter(function (x) {
    return !existingExternals.has(x);
  });

  if (newExternals.length > 0) {
    target = _extends({}, target, {
      external: [].concat(target.external, newExternals)
    });
  }

  var existingSplitIds = new Set(target.activeSplits.map(function (s) {
    return s.id;
  }));
  var newSplits = (_from$activeSplits$fi = from.activeSplits.filter(function (s) {
    return !existingSplitIds.has(s.id);
  })) != null ? _from$activeSplits$fi : [];

  if (newSplits.length > 0) {
    target = _extends({}, target, {
      activeSplits: [].concat(target.activeSplits, newSplits)
    });
  }

  return target;
}
var convertBundlesToComponentRenderData = function convertBundlesToComponentRenderData(bundles, compMetas) {
  if (bundles.length === 0) {
    return null;
  }

  var mergedBundles = bundles.reduce(function (prev, cur) {
    return mergeBundles(prev, cur);
  });
  return prepComponentData.apply(void 0, [mergedBundles].concat(compMetas));
};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var runtime_1 = /*#__PURE__*/createCommonjsModule(function (module) {
  /**
   * Copyright (c) 2014-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var runtime = function (exports) {

    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var undefined$1; // More compressible than void 0.

    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

    function define(obj, key, value) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
      return obj[key];
    }

    try {
      // IE 8 has a broken Object.defineProperty that only works on DOM objects.
      define({}, "");
    } catch (err) {
      define = function define(obj, key, value) {
        return obj[key] = value;
      };
    }

    function wrap(innerFn, outerFn, self, tryLocsList) {
      // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
      var generator = Object.create(protoGenerator.prototype);
      var context = new Context(tryLocsList || []); // The ._invoke method unifies the implementations of the .next,
      // .throw, and .return methods.

      generator._invoke = makeInvokeMethod(innerFn, self, context);
      return generator;
    }

    exports.wrap = wrap; // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.

    function tryCatch(fn, obj, arg) {
      try {
        return {
          type: "normal",
          arg: fn.call(obj, arg)
        };
      } catch (err) {
        return {
          type: "throw",
          arg: err
        };
      }
    }

    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed"; // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.

    var ContinueSentinel = {}; // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.

    function Generator() {}

    function GeneratorFunction() {}

    function GeneratorFunctionPrototype() {} // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.


    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function () {
      return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
      // This environment has a native %IteratorPrototype%; use it instead
      // of the polyfill.
      IteratorPrototype = NativeIteratorPrototype;
    }

    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    define(Gp, "constructor", GeneratorFunctionPrototype);
    define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"); // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.

    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function (method) {
        define(prototype, method, function (arg) {
          return this._invoke(method, arg);
        });
      });
    }

    exports.isGeneratorFunction = function (genFun) {
      var ctor = typeof genFun === "function" && genFun.constructor;
      return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
      // do is to check its .name property.
      (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };

    exports.mark = function (genFun) {
      if (Object.setPrototypeOf) {
        Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
      } else {
        genFun.__proto__ = GeneratorFunctionPrototype;
        define(genFun, toStringTagSymbol, "GeneratorFunction");
      }

      genFun.prototype = Object.create(Gp);
      return genFun;
    }; // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.


    exports.awrap = function (arg) {
      return {
        __await: arg
      };
    };

    function AsyncIterator(generator, PromiseImpl) {
      function invoke(method, arg, resolve, reject) {
        var record = tryCatch(generator[method], generator, arg);

        if (record.type === "throw") {
          reject(record.arg);
        } else {
          var result = record.arg;
          var value = result.value;

          if (value && typeof value === "object" && hasOwn.call(value, "__await")) {
            return PromiseImpl.resolve(value.__await).then(function (value) {
              invoke("next", value, resolve, reject);
            }, function (err) {
              invoke("throw", err, resolve, reject);
            });
          }

          return PromiseImpl.resolve(value).then(function (unwrapped) {
            // When a yielded Promise is resolved, its final value becomes
            // the .value of the Promise<{value,done}> result for the
            // current iteration.
            result.value = unwrapped;
            resolve(result);
          }, function (error) {
            // If a rejected Promise was yielded, throw the rejection back
            // into the async generator function so it can be handled there.
            return invoke("throw", error, resolve, reject);
          });
        }
      }

      var previousPromise;

      function enqueue(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }

        return previousPromise = // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
        // invocations of the iterator.
        callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      } // Define the unified helper method that is used to implement .next,
      // .throw, and .return (see defineIteratorMethods).


      this._invoke = enqueue;
    }

    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
      return this;
    });
    exports.AsyncIterator = AsyncIterator; // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.

    exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
      if (PromiseImpl === void 0) PromiseImpl = Promise;
      var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
      return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function (result) {
        return result.done ? result.value : iter.next();
      });
    };

    function makeInvokeMethod(innerFn, self, context) {
      var state = GenStateSuspendedStart;
      return function invoke(method, arg) {
        if (state === GenStateExecuting) {
          throw new Error("Generator is already running");
        }

        if (state === GenStateCompleted) {
          if (method === "throw") {
            throw arg;
          } // Be forgiving, per 25.3.3.3.3 of the spec:
          // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume


          return doneResult();
        }

        context.method = method;
        context.arg = arg;

        while (true) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if (context.method === "next") {
            // Setting context._sent for legacy support of Babel's
            // function.sent implementation.
            context.sent = context._sent = context.arg;
          } else if (context.method === "throw") {
            if (state === GenStateSuspendedStart) {
              state = GenStateCompleted;
              throw context.arg;
            }

            context.dispatchException(context.arg);
          } else if (context.method === "return") {
            context.abrupt("return", context.arg);
          }

          state = GenStateExecuting;
          var record = tryCatch(innerFn, self, context);

          if (record.type === "normal") {
            // If an exception is thrown from innerFn, we leave state ===
            // GenStateExecuting and loop back for another invocation.
            state = context.done ? GenStateCompleted : GenStateSuspendedYield;

            if (record.arg === ContinueSentinel) {
              continue;
            }

            return {
              value: record.arg,
              done: context.done
            };
          } else if (record.type === "throw") {
            state = GenStateCompleted; // Dispatch the exception by looping back around to the
            // context.dispatchException(context.arg) call above.

            context.method = "throw";
            context.arg = record.arg;
          }
        }
      };
    } // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.


    function maybeInvokeDelegate(delegate, context) {
      var method = delegate.iterator[context.method];

      if (method === undefined$1) {
        // A .throw or .return when the delegate iterator has no .throw
        // method always terminates the yield* loop.
        context.delegate = null;

        if (context.method === "throw") {
          // Note: ["return"] must be used for ES3 parsing compatibility.
          if (delegate.iterator["return"]) {
            // If the delegate iterator has a return method, give it a
            // chance to clean up.
            context.method = "return";
            context.arg = undefined$1;
            maybeInvokeDelegate(delegate, context);

            if (context.method === "throw") {
              // If maybeInvokeDelegate(context) changed context.method from
              // "return" to "throw", let that override the TypeError below.
              return ContinueSentinel;
            }
          }

          context.method = "throw";
          context.arg = new TypeError("The iterator does not provide a 'throw' method");
        }

        return ContinueSentinel;
      }

      var record = tryCatch(method, delegate.iterator, context.arg);

      if (record.type === "throw") {
        context.method = "throw";
        context.arg = record.arg;
        context.delegate = null;
        return ContinueSentinel;
      }

      var info = record.arg;

      if (!info) {
        context.method = "throw";
        context.arg = new TypeError("iterator result is not an object");
        context.delegate = null;
        return ContinueSentinel;
      }

      if (info.done) {
        // Assign the result of the finished delegate to the temporary
        // variable specified by delegate.resultName (see delegateYield).
        context[delegate.resultName] = info.value; // Resume execution at the desired location (see delegateYield).

        context.next = delegate.nextLoc; // If context.method was "throw" but the delegate handled the
        // exception, let the outer generator proceed normally. If
        // context.method was "next", forget context.arg since it has been
        // "consumed" by the delegate iterator. If context.method was
        // "return", allow the original .return call to continue in the
        // outer generator.

        if (context.method !== "return") {
          context.method = "next";
          context.arg = undefined$1;
        }
      } else {
        // Re-yield the result returned by the delegate method.
        return info;
      } // The delegate iterator is finished, so forget it and continue with
      // the outer generator.


      context.delegate = null;
      return ContinueSentinel;
    } // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.


    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator"); // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.

    define(Gp, iteratorSymbol, function () {
      return this;
    });
    define(Gp, "toString", function () {
      return "[object Generator]";
    });

    function pushTryEntry(locs) {
      var entry = {
        tryLoc: locs[0]
      };

      if (1 in locs) {
        entry.catchLoc = locs[1];
      }

      if (2 in locs) {
        entry.finallyLoc = locs[2];
        entry.afterLoc = locs[3];
      }

      this.tryEntries.push(entry);
    }

    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal";
      delete record.arg;
      entry.completion = record;
    }

    function Context(tryLocsList) {
      // The root entry object (effectively a try statement without a catch
      // or a finally block) gives us a place to store values thrown from
      // locations where there is no enclosing try statement.
      this.tryEntries = [{
        tryLoc: "root"
      }];
      tryLocsList.forEach(pushTryEntry, this);
      this.reset(true);
    }

    exports.keys = function (object) {
      var keys = [];

      for (var key in object) {
        keys.push(key);
      }

      keys.reverse(); // Rather than returning an object with a next method, we keep
      // things simple and return the next function itself.

      return function next() {
        while (keys.length) {
          var key = keys.pop();

          if (key in object) {
            next.value = key;
            next.done = false;
            return next;
          }
        } // To avoid creating an additional object, we just hang the .value
        // and .done properties off the next function object itself. This
        // also ensures that the minifier will not anonymize the function.


        next.done = true;
        return next;
      };
    };

    function values(iterable) {
      if (iterable) {
        var iteratorMethod = iterable[iteratorSymbol];

        if (iteratorMethod) {
          return iteratorMethod.call(iterable);
        }

        if (typeof iterable.next === "function") {
          return iterable;
        }

        if (!isNaN(iterable.length)) {
          var i = -1,
              next = function next() {
            while (++i < iterable.length) {
              if (hasOwn.call(iterable, i)) {
                next.value = iterable[i];
                next.done = false;
                return next;
              }
            }

            next.value = undefined$1;
            next.done = true;
            return next;
          };

          return next.next = next;
        }
      } // Return an iterator with no values.


      return {
        next: doneResult
      };
    }

    exports.values = values;

    function doneResult() {
      return {
        value: undefined$1,
        done: true
      };
    }

    Context.prototype = {
      constructor: Context,
      reset: function reset(skipTempReset) {
        this.prev = 0;
        this.next = 0; // Resetting context._sent for legacy support of Babel's
        // function.sent implementation.

        this.sent = this._sent = undefined$1;
        this.done = false;
        this.delegate = null;
        this.method = "next";
        this.arg = undefined$1;
        this.tryEntries.forEach(resetTryEntry);

        if (!skipTempReset) {
          for (var name in this) {
            // Not sure about the optimal order of these conditions:
            if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
              this[name] = undefined$1;
            }
          }
        }
      },
      stop: function stop() {
        this.done = true;
        var rootEntry = this.tryEntries[0];
        var rootRecord = rootEntry.completion;

        if (rootRecord.type === "throw") {
          throw rootRecord.arg;
        }

        return this.rval;
      },
      dispatchException: function dispatchException(exception) {
        if (this.done) {
          throw exception;
        }

        var context = this;

        function handle(loc, caught) {
          record.type = "throw";
          record.arg = exception;
          context.next = loc;

          if (caught) {
            // If the dispatched exception was caught by a catch block,
            // then let that catch block handle the exception normally.
            context.method = "next";
            context.arg = undefined$1;
          }

          return !!caught;
        }

        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          var record = entry.completion;

          if (entry.tryLoc === "root") {
            // Exception thrown outside of any try block that could handle
            // it, so set the completion value of the entire function to
            // throw the exception.
            return handle("end");
          }

          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn.call(entry, "catchLoc");
            var hasFinally = hasOwn.call(entry, "finallyLoc");

            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              } else if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else if (hasCatch) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              }
            } else if (hasFinally) {
              if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else {
              throw new Error("try statement without catch or finally");
            }
          }
        }
      },
      abrupt: function abrupt(type, arg) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }

        if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
          // Ignore the finally entry if control is not jumping to a
          // location outside the try/catch block.
          finallyEntry = null;
        }

        var record = finallyEntry ? finallyEntry.completion : {};
        record.type = type;
        record.arg = arg;

        if (finallyEntry) {
          this.method = "next";
          this.next = finallyEntry.finallyLoc;
          return ContinueSentinel;
        }

        return this.complete(record);
      },
      complete: function complete(record, afterLoc) {
        if (record.type === "throw") {
          throw record.arg;
        }

        if (record.type === "break" || record.type === "continue") {
          this.next = record.arg;
        } else if (record.type === "return") {
          this.rval = this.arg = record.arg;
          this.method = "return";
          this.next = "end";
        } else if (record.type === "normal" && afterLoc) {
          this.next = afterLoc;
        }

        return ContinueSentinel;
      },
      finish: function finish(finallyLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.finallyLoc === finallyLoc) {
            this.complete(entry.completion, entry.afterLoc);
            resetTryEntry(entry);
            return ContinueSentinel;
          }
        }
      },
      "catch": function _catch(tryLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;

            if (record.type === "throw") {
              var thrown = record.arg;
              resetTryEntry(entry);
            }

            return thrown;
          }
        } // The context.catch method must only be called with a location
        // argument that corresponds to a known catch block.


        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(iterable, resultName, nextLoc) {
        this.delegate = {
          iterator: values(iterable),
          resultName: resultName,
          nextLoc: nextLoc
        };

        if (this.method === "next") {
          // Deliberately forget the last sent value so that we don't
          // accidentally pass it on to the delegate.
          this.arg = undefined$1;
        }

        return ContinueSentinel;
      }
    }; // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.

    return exports;
  }( // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   module.exports );

  try {
    regeneratorRuntime = runtime;
  } catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") {
      globalThis.regeneratorRuntime = runtime;
    } else {
      Function("r", "regeneratorRuntime = r")(runtime);
    }
  }
});

function useForceUpdate() {
  var _React$useState = useState(0),
      setTick = _React$useState[1];

  var update = useCallback(function () {
    setTick(function (tick) {
      return tick + 1;
    });
  }, []);
  return update;
}
function useStableLookupSpec(spec) {
  return useStableLookupSpecs(spec)[0];
}
function useStableLookupSpecs() {
  for (var _len = arguments.length, specs = new Array(_len), _key = 0; _key < _len; _key++) {
    specs[_key] = arguments[_key];
  }

  var _React$useState2 = useState(specs),
      stableSpecs = _React$useState2[0],
      setStableSpecs = _React$useState2[1];

  useEffect(function () {
    if (specs.length !== stableSpecs.length || specs.some(function (s, i) {
      return !areLookupSpecsEqual(s, stableSpecs[i]);
    })) {
      setStableSpecs(specs);
    }
  }, [specs, stableSpecs]);
  return stableSpecs;
}

function areLookupSpecsEqual(spec1, spec2) {
  if (spec1 === spec2) {
    return true;
  }

  if (typeof spec1 !== typeof spec2) {
    return false;
  }

  var fullSpec1 = toFullLookup(spec1);
  var fullSpec2 = toFullLookup(spec2);
  return (isNameSpec(fullSpec1) && isNameSpec(fullSpec2) && fullSpec1.name === fullSpec2.name && fullSpec1.isCode === fullSpec2.isCode || isPathSpec(fullSpec1) && isPathSpec(fullSpec2) && fullSpec1.path === fullSpec2.path) && fullSpec1.projectId === fullSpec2.projectId;
}

function isNameSpec(lookup) {
  return 'name' in lookup;
}

function isPathSpec(lookup) {
  return 'path' in lookup;
}

function toFullLookup(lookup) {
  var namePart = typeof lookup === 'string' ? lookup : lookup.name;
  var projectId = typeof lookup === 'string' ? undefined : lookup.projectId;
  var codeComponent = typeof lookup === 'string' ? undefined : lookup.isCode;

  if (codeComponent !== true && namePart.startsWith('/')) {
    return {
      path: normalizePath(namePart),
      projectId: projectId
    };
  } else {
    return {
      name: codeComponent ? namePart : normalizeName(namePart),
      rawName: namePart.trim(),
      projectId: projectId,
      isCode: codeComponent
    };
  }
}

function normalizePath(path) {
  return path.trim();
}

function normalizeName(name) {
  // Not a full normalization, but should be good enough
  return pascalcase(name).trim();
}

function useIsMounted() {
  var ref = useRef(false);
  var isMounted = useCallback(function () {
    return ref.current;
  }, []);
  useEffect(function () {
    ref.current = true;
    return function () {
      ref.current = false;
    };
  }, []);
  return isMounted;
}
/**
 * Check if `lookup` resolves to `pagePath`. If it's a match, return an object
 * containing path params; otherwise, returns false.
 *
 * For example,
 * - `matchesPagePath("/hello/[name]", "/hello/world")` -> `{params: {name:
 *   "world"}}`
 * - `matchesPagePath("/hello/[name]", "/")` -> `false`
 * - `matchesPagePath("/", "")` -> `{params: {}}`
 */

function matchesPagePath(pagePath, lookup) {
  var _lookup$match;

  // Remove trailing slashes from both `pagePath` and `lookup`.
  pagePath = pagePath.replace(/^\/*/, '').replace(/\/*$/, '');
  lookup = lookup.replace(/^\/*/, '').replace(/\/*$/, ''); // paramNames will contain a list of parameter names; e.g. if pagePath
  // is "/products/[slug]/[variant]" it will contain ["slug", "variant"].

  var paramNames = (pagePath.match(/\[([^\]]*)\]/g) || []).map(function (group) {
    return group.slice(1, -1);
  });
  var pagePathRegExp = new RegExp('^' + pagePath.replace(/\[[^\]]*\]/g, '([^/]+)') + '$');
  var maybeVals = (_lookup$match = lookup.match(pagePathRegExp)) == null ? void 0 : _lookup$match.slice(1);

  if (!maybeVals) {
    return false;
  }

  var params = {};

  for (var i = 0; i < paramNames.length; i++) {
    params[paramNames[i]] = maybeVals[i];
  }

  return {
    params: params
  };
}
function isDynamicPagePath(path) {
  return !!path.match(/\[[^/]*\]/);
}

function matchesCompMeta(lookup, meta) {
  if (lookup.projectId && meta.projectId !== lookup.projectId) {
    return false;
  }

  return isNameSpec(lookup) ? (lookup.name === meta.name || lookup.rawName === meta.name || lookup.rawName === meta.displayName) && (lookup.isCode == null || lookup.isCode === meta.isCode) : !!(meta.path && matchesPagePath(meta.path, lookup.path));
}

function getCompMetas(metas, lookup) {
  var full = toFullLookup(lookup);
  return metas.filter(function (meta) {
    return matchesCompMeta(full, meta);
  }).map(function (meta) {
    if (isNameSpec(full) || !meta.path) {
      return meta;
    }

    var match = matchesPagePath(meta.path, full.path);

    if (!match) {
      return meta;
    }

    return _extends({}, meta, {
      params: match.params
    });
  });
}
function getLookupSpecName(lookup) {
  if (typeof lookup === 'string') {
    return lookup;
  } else if (lookup.projectId) {
    return lookup.name + " (project " + lookup.projectId + ")";
  } else {
    return lookup.name;
  }
}
function uniq(elements) {
  return Array.from(new Set(elements));
}

function getFirstCompMeta(metas, lookup) {
  var filtered = getCompMetas(metas, lookup);
  return filtered.length === 0 ? undefined : filtered[0];
}

var ComponentLookup = /*#__PURE__*/function () {
  function ComponentLookup(bundle, registry) {
    this.bundle = bundle;
    this.registry = registry;
  }

  var _proto = ComponentLookup.prototype;

  _proto.getComponentMeta = function getComponentMeta(spec) {
    var compMeta = getFirstCompMeta(this.bundle.components, spec);
    return compMeta;
  };

  _proto.getComponent = function getComponent(spec, opts) {
    if (opts === void 0) {
      opts = {};
    }

    var compMeta = getFirstCompMeta(this.bundle.components, spec);

    if (!compMeta) {
      throw new Error("Component not found: " + spec);
    }

    var moduleName = compMeta.entry;

    if (!this.registry.hasModule(moduleName, opts)) {
      throw new Error("Component not yet fetched: " + compMeta.name);
    }

    var entry = this.registry.load(moduleName, {
      forceOriginal: opts.forceOriginal
    });
    return !opts.forceOriginal && typeof (entry == null ? void 0 : entry.getPlasmicComponent) === 'function' ? entry.getPlasmicComponent() : entry["default"];
  };

  _proto.hasComponent = function hasComponent(spec) {
    var compMeta = getFirstCompMeta(this.bundle.components, spec);

    if (compMeta) {
      return this.registry.hasModule(compMeta.entry);
    }

    return false;
  };

  _proto.getGlobalContexts = function getGlobalContexts() {
    var _this = this;

    var customGlobalMetas = this.bundle.globalGroups.filter(function (m) {
      return m.type === 'global-user-defined';
    });
    return customGlobalMetas.map(function (meta) {
      return {
        meta: meta,
        context: _this.registry.load(meta.contextFile)["default"]
      };
    });
  };

  _proto.getGlobalContextsProvider = function getGlobalContextsProvider(spec) {
    var compMeta = getFirstCompMeta(this.bundle.components, spec);
    var projectMeta = compMeta ? this.bundle.projects.find(function (x) {
      return x.id === compMeta.projectId;
    }) : undefined;

    if (!projectMeta || !projectMeta.globalContextsProviderFileName || !this.registry.hasModule(projectMeta.globalContextsProviderFileName)) {
      return undefined;
    }

    var entry = this.registry.load(projectMeta.globalContextsProviderFileName);
    return typeof (entry == null ? void 0 : entry.getPlasmicComponent) === 'function' ? entry.getPlasmicComponent() : entry["default"];
  };

  _proto.getRootProvider = function getRootProvider() {
    var entry = this.registry.load('root-provider.js');
    return entry["default"];
  };

  _proto.getCss = function getCss() {
    // We can probably always get the modules from the browser build
    return this.bundle.modules.browser.filter(function (mod) {
      return mod.type === 'asset' && mod.fileName.endsWith('css');
    });
  };

  _proto.getRemoteFonts = function getRemoteFonts() {
    return this.bundle.projects.flatMap(function (p) {
      return p.remoteFonts;
    });
  };

  return ComponentLookup;
}();

function getPlasmicCookieValues() {
  return Object.fromEntries(document.cookie.split('; ').filter(function (cookie) {
    return cookie.includes('plasmic:');
  }).map(function (cookie) {
    return cookie.split('=');
  }).map(function (_ref) {
    var key = _ref[0],
        value = _ref[1];
    return [key.split(':')[1], value];
  }));
}
function updatePlasmicCookieValue(key, value) {
  document.cookie = "plasmic:" + key + "=" + value;
}
function ensureVariationCookies(variation) {
  if (variation === void 0) {
    variation = {};
  }

  Object.keys(variation).map(function (variationKey) {
    var sliceId = variation[variationKey];
    updatePlasmicCookieValue(variationKey, sliceId);
  });
}
var getGlobalVariantsFromSplits = function getGlobalVariantsFromSplits(splits, variation) {
  var globalVariants = [];
  Object.keys(variation).map(function (variationKey) {
    var _variationKey$split = variationKey.split('.'),
        splitId = _variationKey$split[1];

    var sliceId = variation[variationKey];
    var split = splits.find(function (s) {
      return s.id === splitId || s.externalId === splitId;
    });

    if (split) {
      var slice = split.slices.find(function (s) {
        return s.id === sliceId || s.externalId === sliceId;
      });

      if (slice) {
        slice.contents.map(function (x) {
          globalVariants.push({
            name: x.group,
            value: x.variant,
            projectId: x.projectId
          });
        });
      }
    }
  });
  return globalVariants;
};
var mergeGlobalVariantsSpec = function mergeGlobalVariantsSpec(target, from) {
  var result = [].concat(target);
  var existingGlobalVariants = new Set(target.map(function (t) {
    var _t$projectId;

    return t.name + "-" + ((_t$projectId = t.projectId) != null ? _t$projectId : '');
  }));
  var newGlobals = from.filter(function (t) {
    var _t$projectId2;

    return !existingGlobalVariants.has(t.name + "-" + ((_t$projectId2 = t.projectId) != null ? _t$projectId2 : ''));
  });

  if (newGlobals.length > 0) {
    result = [].concat(result, newGlobals);
  }

  return result;
};

var PlasmicRootContext = /*#__PURE__*/createContext(undefined);
/**
 * PlasmicRootProvider should be used at the root of your page
 * or application.
 */

function PlasmicRootProvider(props) {
  var globalVariants = props.globalVariants,
      prefetchedData = props.prefetchedData,
      children = props.children,
      skipCss = props.skipCss,
      skipFonts = props.skipFonts,
      prefetchedQueryData = props.prefetchedQueryData,
      suspenseForQueryData = props.suspenseForQueryData,
      globalContextsProps = props.globalContextsProps,
      variation = props.variation,
      translator = props.translator,
      Head = props.Head,
      pageParams = props.pageParams,
      pageQuery = props.pageQuery;
  var loader = props.loader.__internal;

  if (prefetchedData) {
    loader.registerPrefetchedBundle(prefetchedData == null ? void 0 : prefetchedData.bundle);
  }

  var _React$useState = useState(loader.getActiveSplits()),
      splits = _React$useState[0],
      setSplits = _React$useState[1];

  var forceUpdate = useForceUpdate();
  var watcher = useMemo(function () {
    return {
      onDataFetched: function onDataFetched() {
        setSplits(loader.getActiveSplits());
        forceUpdate();
      }
    };
  }, [loader, forceUpdate]);
  useEffect(function () {
    loader.subscribePlasmicRoot(watcher);
    return function () {
      return loader.unsubscribePlasmicRoot(watcher);
    };
  }, [watcher, loader]);
  useEffect(function () {
    ensureVariationCookies(variation);
    loader.trackRender({
      renderCtx: {
        // We track the provider as a single entity
        rootComponentId: 'provider',
        teamIds: loader.getTeamIds(),
        projectIds: loader.getProjectIds()
      },
      variation: variation
    });
  }, [loader, variation]);
  var value = useMemo(function () {
    return {
      globalVariants: mergeGlobalVariantsSpec(globalVariants != null ? globalVariants : [], getGlobalVariantsFromSplits(splits, variation != null ? variation : {})),
      globalContextsProps: globalContextsProps,
      loader: loader,
      variation: variation,
      translator: translator,
      Head: Head
    };
  }, [globalVariants, variation, globalContextsProps, loader, splits, translator, Head]);
  return createElement(PlasmicQueryDataProvider, {
    prefetchedCache: prefetchedQueryData,
    suspense: suspenseForQueryData
  }, createElement(PlasmicRootContext.Provider, {
    value: value
  }, !skipCss && createElement(PlasmicCss, {
    loader: loader,
    prefetchedData: prefetchedData,
    skipFonts: skipFonts
  }), createElement(PageParamsProvider, {
    params: pageParams,
    query: pageQuery
  }, children)));
}
/**
 * Inject all css modules as <style/> tags. We can't use the usual styleInjector postcss
 * uses because that doesn't work on the server side for SSR.
 */

var PlasmicCss = /*#__PURE__*/memo(function PlasmicCss(props) {
  var loader = props.loader,
      prefetchedData = props.prefetchedData,
      skipFonts = props.skipFonts;

  var _React$useState2 = useState(!!prefetchedData),
      useScopedCss = _React$useState2[0],
      setUseScopedCss = _React$useState2[1];

  var builtCss = buildCss(loader, {
    scopedCompMetas: useScopedCss && prefetchedData ? prefetchedData.bundle.components : undefined,
    skipFonts: skipFonts
  });
  var forceUpdate = useForceUpdate();
  var watcher = useMemo(function () {
    return {
      onDataFetched: function onDataFetched() {
        // If new data has been fetched, then use all the fetched css
        setUseScopedCss(false);
        forceUpdate();
      }
    };
  }, [loader, forceUpdate]);
  useEffect(function () {
    loader.subscribePlasmicRoot(watcher);
    return function () {
      return loader.unsubscribePlasmicRoot(watcher);
    };
  }, [watcher, loader]);
  return createElement("style", {
    dangerouslySetInnerHTML: {
      __html: builtCss
    }
  });
});

function buildCss(loader, opts) {
  var scopedCompMetas = opts.scopedCompMetas,
      skipFonts = opts.skipFonts;
  var cssFiles = scopedCompMetas && new Set(['entrypoint.css'].concat(scopedCompMetas.map(function (c) {
    return c.cssFile;
  })));
  var cssModules = loader.getLookup().getCss().filter(function (f) {
    return !cssFiles || cssFiles.has(f.fileName);
  });

  var getPri = function getPri(fileName) {
    return fileName === 'entrypoint.css' ? 0 : 1;
  };

  var compareModules = function compareModules(a, b) {
    return getPri(a.fileName) !== getPri(b.fileName) ? getPri(a.fileName) - getPri(b.fileName) : a.fileName.localeCompare(b.fileName);
  };

  cssModules.sort(compareModules);
  var remoteFonts = loader.getLookup().getRemoteFonts(); // Make sure the @import statements come at the front of css

  return "\n    " + (skipFonts ? '' : remoteFonts.map(function (f) {
    return "@import url('" + f.url + "');";
  }).join('\n')) + "\n    " + cssModules.map(function (mod) {
    return mod.source;
  }).join('\n') + "\n  ";
}

function usePlasmicRootContext() {
  return useContext(PlasmicRootContext);
}

/**
 * We don't actually make use of the global variant React contexts generated
 * in the bundle.  That's because we would have to wait until the data is
 * loaded before we can set up the context providers, but setting up context
 * providers will mutate the React tree and invalidate all the children. That means
 * once data comes in, we'll re-render the React tree from the providers down
 * in a way that will lose all existing React state.  Therefore, instead,
 * we always have a single context provided -- the PlasmicRootContext -- and we
 * create these fake useGlobalVariant() hooks that just read from that
 * PlasmicRootContext.  This allows us to have a stable React tree before and
 * after the data load.
 */
function createUseGlobalVariant(name, projectId) {
  return function () {
    var _rootContext$globalVa;

    var rootContext = usePlasmicRootContext();

    if (!rootContext) {
      return undefined;
    }

    var loader = rootContext.loader;
    var spec = [].concat(loader.getGlobalVariants(), (_rootContext$globalVa = rootContext.globalVariants) != null ? _rootContext$globalVa : []).find(function (spec) {
      return spec.name === name && (!spec.projectId || spec.projectId === projectId);
    });
    return spec ? spec.value : undefined;
  };
}

var isBrowser = typeof window !== 'undefined';
function initPlasmicLoader(opts) {
  var internal = new InternalPlasmicComponentLoader(opts);
  return new PlasmicComponentLoader(internal);
}
var InternalPlasmicComponentLoader = /*#__PURE__*/function () {
  function InternalPlasmicComponentLoader(opts) {
    this.opts = opts;
    this.subs = [];
    this.roots = [];
    this.globalVariants = [];
    this.bundle = {
      modules: {
        browser: [],
        server: []
      },
      components: [],
      globalGroups: [],
      external: [],
      projects: [],
      activeSplits: []
    };
    this.substitutedComponents = {};
    this.substitutedGlobalVariantHooks = {};
    this.registry = Registry.getInstance();
    this.fetcher = new PlasmicModulesFetcher(opts);
    this.tracker = new PlasmicTracker({
      projectIds: opts.projects.map(function (p) {
        return p.id;
      }),
      platform: opts.platform,
      preview: opts.preview
    });
    this.registerModules({
      react: React__default,
      'react-dom': ReactDOM,
      'react/jsx-runtime': jsxRuntime,
      'react/jsx-dev-runtime': jsxDevRuntime,
      // Also inject @plasmicapp/query and @plasmicapp/host to use the
      // same contexts here and in loader-downloaded code.
      '@plasmicapp/query': PlasmicQuery,
      '@plasmicapp/host': PlasmicHost,
      '@plasmicapp/loader-runtime-registry': {
        components: this.substitutedComponents,
        globalVariantHooks: this.substitutedGlobalVariantHooks
      }
    });
  }

  var _proto = InternalPlasmicComponentLoader.prototype;

  _proto.setGlobalVariants = function setGlobalVariants(globalVariants) {
    this.globalVariants = globalVariants;
  };

  _proto.getGlobalVariants = function getGlobalVariants() {
    return this.globalVariants;
  };

  _proto.registerModules = function registerModules(modules) {
    var _this = this;

    if (Object.keys(modules).some(function (name) {
      return _this.registry.getRegisteredModule(name) !== modules[name];
    })) {
      if (!this.registry.isEmpty()) {
        console.warn('Calling PlasmicComponentLoader.registerModules() after Plasmic component has rendered; starting over.');
        this.registry.clear();
      }

      for (var _i = 0, _Object$keys = Object.keys(modules); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        this.registry.register(key, modules[key]);
      }
    }
  };

  _proto.substituteComponent = function substituteComponent(component, name) {
    if (!this.registry.isEmpty()) {
      console.warn('Calling PlasmicComponentLoader.registerSubstitution() after Plasmic component has rendered; starting over.');
      this.registry.clear();
    }

    this.subs.push({
      lookup: name,
      component: component
    });
  };

  _proto.registerComponent = function registerComponent$1(component, meta) {
    var _meta$importPath;

    this.substituteComponent(component, {
      name: meta.name,
      isCode: true
    }); // Import path is not used as we will use component substitution

    registerComponent(component, _extends({}, meta, {
      importPath: (_meta$importPath = meta.importPath) != null ? _meta$importPath : ''
    }));
  };

  _proto.registerGlobalContext = function registerGlobalContext$1(context, meta) {
    var _meta$importPath2;

    this.substituteComponent(context, {
      name: meta.name,
      isCode: true
    }); // Import path is not used as we will use component substitution

    registerGlobalContext(context, _extends({}, meta, {
      importPath: (_meta$importPath2 = meta.importPath) != null ? _meta$importPath2 : ''
    }));
  };

  _proto.registerTrait = function registerTrait$1(trait, meta) {
    registerTrait(trait, meta);
  };

  _proto.registerPrefetchedBundle = function registerPrefetchedBundle(bundle) {
    this.mergeBundle(bundle);
  };

  _proto.subscribePlasmicRoot = function subscribePlasmicRoot(watcher) {
    this.roots.push(watcher);
  };

  _proto.unsubscribePlasmicRoot = function unsubscribePlasmicRoot(watcher) {
    var index = this.roots.indexOf(watcher);

    if (index >= 0) {
      this.roots.splice(index, 1);
    }
  };

  _proto.clearCache = function clearCache() {
    this.bundle = {
      modules: {
        browser: [],
        server: []
      },
      components: [],
      globalGroups: [],
      external: [],
      projects: [],
      activeSplits: []
    };
    this.registry.clear();
  };

  _proto.maybeGetCompMetas = function maybeGetCompMetas() {
    for (var _len = arguments.length, specs = new Array(_len), _key = 0; _key < _len; _key++) {
      specs[_key] = arguments[_key];
    }

    return _maybeGetCompMetas(this.bundle.components, specs);
  };

  _proto.maybeFetchComponentData = /*#__PURE__*/function () {
    var _maybeFetchComponentData = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee2() {
      var _this2 = this;

      var _len2,
          specs,
          _key2,
          returnWithSpecsToFetch,
          _this$maybeGetCompMet,
          existingMetas,
          missingSpecs,
          _args2 = arguments;

      return runtime_1.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              for (_len2 = _args2.length, specs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                specs[_key2] = _args2[_key2];
              }

              returnWithSpecsToFetch = /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(specsToFetch) {
                  var _this2$maybeGetCompMe, existingMetas2, missingSpecs2;

                  return runtime_1.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return _this2.fetchMissingData({
                            missingSpecs: specsToFetch
                          });

                        case 2:
                          _this2$maybeGetCompMe = _this2.maybeGetCompMetas.apply(_this2, specs), existingMetas2 = _this2$maybeGetCompMe.found, missingSpecs2 = _this2$maybeGetCompMe.missing;

                          if (!(missingSpecs2.length > 0)) {
                            _context.next = 5;
                            break;
                          }

                          return _context.abrupt("return", null);

                        case 5:
                          return _context.abrupt("return", prepComponentData.apply(void 0, [_this2.bundle].concat(existingMetas2)));

                        case 6:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function returnWithSpecsToFetch(_x) {
                  return _ref.apply(this, arguments);
                };
              }();

              if (!this.opts.alwaysFresh) {
                _context2.next = 6;
                break;
              }

              _context2.next = 5;
              return returnWithSpecsToFetch(specs);

            case 5:
              return _context2.abrupt("return", _context2.sent);

            case 6:
              // Else we only fetch actually missing specs
              _this$maybeGetCompMet = this.maybeGetCompMetas.apply(this, specs), existingMetas = _this$maybeGetCompMet.found, missingSpecs = _this$maybeGetCompMet.missing;

              if (!(missingSpecs.length === 0)) {
                _context2.next = 9;
                break;
              }

              return _context2.abrupt("return", prepComponentData.apply(void 0, [this.bundle].concat(existingMetas)));

            case 9:
              _context2.next = 11;
              return returnWithSpecsToFetch(missingSpecs);

            case 11:
              return _context2.abrupt("return", _context2.sent);

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function maybeFetchComponentData() {
      return _maybeFetchComponentData.apply(this, arguments);
    }

    return maybeFetchComponentData;
  }();

  _proto.fetchComponentData = /*#__PURE__*/function () {
    var _fetchComponentData = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee3() {
      var data,
          _this$maybeGetCompMet2,
          missingSpecs,
          _args3 = arguments;

      return runtime_1.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.maybeFetchComponentData.apply(this, _args3);

            case 2:
              data = _context3.sent;

              if (data) {
                _context3.next = 6;
                break;
              }

              _this$maybeGetCompMet2 = this.maybeGetCompMetas.apply(this, _args3), missingSpecs = _this$maybeGetCompMet2.missing;
              throw new Error("Unable to find components " + missingSpecs.map(getLookupSpecName).join(', '));

            case 6:
              return _context3.abrupt("return", data);

            case 7:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function fetchComponentData() {
      return _fetchComponentData.apply(this, arguments);
    }

    return fetchComponentData;
  }();

  _proto.fetchPages = /*#__PURE__*/function () {
    var _fetchPages = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee4(opts) {
      var data;
      return runtime_1.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              this.maybeReportClientSideFetch(function () {
                return "Plasmic: fetching all page metadata in the browser";
              });
              _context4.next = 3;
              return this.fetchAllData();

            case 3:
              data = _context4.sent;
              return _context4.abrupt("return", data.components.filter(function (comp) {
                return comp.isPage && comp.path && ((opts == null ? void 0 : opts.includeDynamicPages) || !isDynamicPagePath(comp.path));
              }));

            case 5:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function fetchPages(_x2) {
      return _fetchPages.apply(this, arguments);
    }

    return fetchPages;
  }();

  _proto.fetchComponents = /*#__PURE__*/function () {
    var _fetchComponents = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee5() {
      var data;
      return runtime_1.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              this.maybeReportClientSideFetch(function () {
                return "Plasmic: fetching all component metadata in the browser";
              });
              _context5.next = 3;
              return this.fetchAllData();

            case 3:
              data = _context5.sent;
              return _context5.abrupt("return", data.components);

            case 5:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function fetchComponents() {
      return _fetchComponents.apply(this, arguments);
    }

    return fetchComponents;
  }();

  _proto.getLookup = function getLookup() {
    return new ComponentLookup(this.bundle, this.registry);
  };

  _proto.getActiveSplits = function getActiveSplits() {
    return this.bundle.activeSplits;
  };

  _proto.trackConversion = function trackConversion(value) {
    if (value === void 0) {
      value = 0;
    }

    this.tracker.trackConversion(value);
  } // @ts-ignore
  ;

  _proto.fetchMissingData =
  /*#__PURE__*/
  function () {
    var _fetchMissingData = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee6(opts) {
      return runtime_1.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              // TODO: do better than just fetching everything
              this.maybeReportClientSideFetch(function () {
                return "Plasmic: fetching missing components in the browser: " + opts.missingSpecs.map(function (spec) {
                  return getLookupSpecName(spec);
                }).join(', ');
              });
              return _context6.abrupt("return", this.fetchAllData());

            case 2:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, this);
    }));

    function fetchMissingData(_x3) {
      return _fetchMissingData.apply(this, arguments);
    }

    return fetchMissingData;
  }();

  _proto.maybeReportClientSideFetch = function maybeReportClientSideFetch(mkMsg) {
    if (isBrowser && this.opts.onClientSideFetch) {
      var msg = mkMsg();

      if (this.opts.onClientSideFetch === 'warn') {
        console.warn(msg);
      } else {
        throw new Error(msg);
      }
    }
  };

  _proto.getActiveVariation = /*#__PURE__*/function () {
    var _getActiveVariation2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee7(opts) {
      return runtime_1.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return this.fetchAllData();

            case 2:
              return _context7.abrupt("return", getActiveVariation(_extends({}, opts, {
                splits: this.bundle.activeSplits
              })));

            case 3:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, this);
    }));

    function getActiveVariation$1(_x4) {
      return _getActiveVariation2.apply(this, arguments);
    }

    return getActiveVariation$1;
  }();

  _proto.getTeamIds = function getTeamIds() {
    return uniq(this.bundle.projects.map(function (p) {
      return p.teamId ? "" + p.teamId + (p.indirect ? '@indirect' : '') : null;
    }).filter(function (x) {
      return !!x;
    }));
  };

  _proto.getProjectIds = function getProjectIds() {
    return uniq(this.bundle.projects.map(function (p) {
      return "" + p.id + (p.indirect ? '@indirect' : '');
    }));
  };

  _proto.trackRender = function trackRender(opts) {
    this.tracker.trackRender(opts);
  };

  _proto.fetchAllData = /*#__PURE__*/function () {
    var _fetchAllData = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee8() {
      var bundle;
      return runtime_1.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return this.ensureFetcher().fetchAllData();

            case 2:
              bundle = _context8.sent;
              this.tracker.trackFetch();
              this.mergeBundle(bundle);
              this.roots.forEach(function (watcher) {
                return watcher.onDataFetched == null ? void 0 : watcher.onDataFetched();
              });
              return _context8.abrupt("return", bundle);

            case 7:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, this);
    }));

    function fetchAllData() {
      return _fetchAllData.apply(this, arguments);
    }

    return fetchAllData;
  }();

  _proto.mergeBundle = function mergeBundle(bundle) {
    this.bundle = mergeBundles(bundle, this.bundle);
    this.refreshRegistry();
  };

  _proto.refreshRegistry = function refreshRegistry() {
    var _this3 = this;

    var _loop = function _loop() {
      var sub = _step.value;
      var metas = getCompMetas(_this3.bundle.components, sub.lookup);
      metas.forEach(function (meta) {
        _this3.substitutedComponents[meta.id] = sub.component;
      });
    };

    // Once we have received data, we register components to
    // substitute.  We had to wait for data to do this so
    // that we can look up the right module name to substitute
    // in component meta.
    for (var _iterator = _createForOfIteratorHelperLoose(this.subs), _step; !(_step = _iterator()).done;) {
      _loop();
    } // We also swap global variants' useXXXGlobalVariant() hook with
    // a fake one that just reads from the PlasmicRootContext. Because
    // global variant values are not supplied by the generated global variant
    // context providers, but instead by <PlasmicRootProvider/> and by
    // PlasmicComponentLoader.setGlobalVariants(), we redirect these
    // hooks to read from them instead.


    for (var _iterator2 = _createForOfIteratorHelperLoose(this.bundle.globalGroups), _step2; !(_step2 = _iterator2()).done;) {
      var globalGroup = _step2.value;

      if (globalGroup.type !== 'global-screen') {
        this.substitutedGlobalVariantHooks[globalGroup.id] = createUseGlobalVariant(globalGroup.name, globalGroup.projectId);
      }
    }

    this.registry.updateModules(this.bundle);
  };

  _proto.ensureFetcher = function ensureFetcher() {
    if (!this.fetcher) {
      throw new Error("You must first call PlasmicComponentLoader.init()");
    }

    return this.fetcher;
  };

  return InternalPlasmicComponentLoader;
}();

function _maybeGetCompMetas(metas, specs) {
  var found = new Set();
  var missing = [];

  for (var _iterator3 = _createForOfIteratorHelperLoose(specs), _step3; !(_step3 = _iterator3()).done;) {
    var spec = _step3.value;
    var filteredMetas = getCompMetas(metas, spec);

    if (filteredMetas.length > 0) {
      filteredMetas.forEach(function (meta) {
        return found.add(meta);
      });
    } else {
      missing.push(spec);
    }
  }

  return {
    found: Array.from(found.keys()),
    missing: missing
  };
}
/**
 * Library for fetching component data, and registering
 * custom components.
 */


var PlasmicComponentLoader = /*#__PURE__*/function () {
  function PlasmicComponentLoader(internal) {
    this.warnedRegisterComponent = false;
    this.__internal = internal;
  }
  /**
   * Sets global variants to be used for all components.  Note that
   * this is not reactive, and will not re-render all components
   * already mounted; instead, it should be used to activate global
   * variants that should always be activated for the lifetime of this
   * app.  If you'd like to reactively change the global variants,
   * you should specify them via <PlasmicRootProvider />
   */


  var _proto2 = PlasmicComponentLoader.prototype;

  _proto2.setGlobalVariants = function setGlobalVariants(globalVariants) {
    this.__internal.setGlobalVariants(globalVariants);
  };

  _proto2.registerModules = function registerModules(modules) {
    this.__internal.registerModules(modules);
  }
  /**
   * Register custom components that should be swapped in for
   * components defined in your project.  You can use this to
   * swap in / substitute a Plasmic component with a "real" component.
   */
  ;

  _proto2.substituteComponent = function substituteComponent(component, name) {
    this.__internal.substituteComponent(component, name);
  };

  _proto2.registerComponent = function registerComponent(component, metaOrName) {
    // 'props' is a required field in CodeComponentMeta
    if (metaOrName && typeof metaOrName === 'object' && 'props' in metaOrName) {
      this.__internal.registerComponent(component, metaOrName);
    } else {
      // Deprecated call
      if (process.env.NODE_ENV === 'development' && !this.warnedRegisterComponent) {
        console.warn("PlasmicLoader: Using deprecated method `registerComponent` for component substitution. " + "Please consider using `substituteComponent` instead.");
        this.warnedRegisterComponent = true;
      }

      this.substituteComponent(component, metaOrName);
    }
  };

  _proto2.registerGlobalContext = function registerGlobalContext(context, meta) {
    this.__internal.registerGlobalContext(context, meta);
  };

  _proto2.registerTrait = function registerTrait(trait, meta) {
    this.__internal.registerTrait(trait, meta);
  }
  /**
   * Pre-fetches component data needed to for PlasmicLoader to render
   * these components.  Should be passed into PlasmicRootProvider as
   * the prefetchedData prop.
   *
   * You can look up a component either by:
   * - the name of the component
   * - the path for a page component
   * - an array of strings that make up parts of the path
   * - object { name: "name_or_path", projectId: ...}, to specify which project
   *   to use, if multiple projects have the same component name
   *
   * Throws an Error if a specified component to fetch does not exist in
   * the Plasmic project.
   */
  ;

  _proto2.fetchComponentData =
  /*#__PURE__*/
  function () {
    var _fetchComponentData2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee9() {
      var _this$__internal;

      var _args9 = arguments;
      return runtime_1.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              return _context9.abrupt("return", (_this$__internal = this.__internal).fetchComponentData.apply(_this$__internal, _args9));

            case 1:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, this);
    }));

    function fetchComponentData() {
      return _fetchComponentData2.apply(this, arguments);
    }

    return fetchComponentData;
  }()
  /**
   * Like fetchComponentData(), but returns null instead of throwing an Error
   * when a component is not found.  Useful when you are implementing a catch-all
   * page and want to check if a specific path had been defined for Plasmic.
   */
  ;

  _proto2.maybeFetchComponentData =
  /*#__PURE__*/
  function () {
    var _maybeFetchComponentData2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee10() {
      var _this$__internal2;

      var _args10 = arguments;
      return runtime_1.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              return _context10.abrupt("return", (_this$__internal2 = this.__internal).maybeFetchComponentData.apply(_this$__internal2, _args10));

            case 1:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, this);
    }));

    function maybeFetchComponentData() {
      return _maybeFetchComponentData2.apply(this, arguments);
    }

    return maybeFetchComponentData;
  }()
  /**
   * Returns all the page component metadata for these projects.
   */
  ;

  _proto2.fetchPages =
  /*#__PURE__*/
  function () {
    var _fetchPages2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee11(opts) {
      return runtime_1.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              return _context11.abrupt("return", this.__internal.fetchPages(opts));

            case 1:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, this);
    }));

    function fetchPages(_x5) {
      return _fetchPages2.apply(this, arguments);
    }

    return fetchPages;
  }()
  /**
   * Returns all components metadata for these projects.
   */
  ;

  _proto2.fetchComponents =
  /*#__PURE__*/
  function () {
    var _fetchComponents2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee12() {
      return runtime_1.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              return _context12.abrupt("return", this.__internal.fetchComponents());

            case 1:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, this);
    }));

    function fetchComponents() {
      return _fetchComponents2.apply(this, arguments);
    }

    return fetchComponents;
  }();

  _proto2._getActiveVariation = /*#__PURE__*/function () {
    var _getActiveVariation3 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee13(opts) {
      return runtime_1.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              return _context13.abrupt("return", this.__internal.getActiveVariation(opts));

            case 1:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13, this);
    }));

    function _getActiveVariation(_x6) {
      return _getActiveVariation3.apply(this, arguments);
    }

    return _getActiveVariation;
  }();

  _proto2.getActiveVariation = /*#__PURE__*/function () {
    var _getActiveVariation4 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee14(opts) {
      return runtime_1.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              return _context14.abrupt("return", this._getActiveVariation({
                traits: opts.traits,
                getKnownValue: function getKnownValue(key) {
                  if (opts.known) {
                    return opts.known[key];
                  } else {
                    var cookies = getPlasmicCookieValues();
                    return cookies[key];
                  }
                },
                updateKnownValue: function updateKnownValue(key, value) {
                  if (!opts.known) {
                    updatePlasmicCookieValue(key, value);
                  }
                }
              }));

            case 1:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14, this);
    }));

    function getActiveVariation(_x7) {
      return _getActiveVariation4.apply(this, arguments);
    }

    return getActiveVariation;
  }();

  _proto2.getExternalVariation = function getExternalVariation(variation) {
    return getExternalIds(this.getActiveSplits(), variation);
  };

  _proto2.getActiveSplits = function getActiveSplits() {
    return this.__internal.getActiveSplits();
  };

  _proto2.trackConversion = function trackConversion(value) {
    if (value === void 0) {
      value = 0;
    }

    this.__internal.trackConversion(value);
  };

  _proto2.clearCache = function clearCache() {
    return this.__internal.clearCache();
  };

  return PlasmicComponentLoader;
}();

/**
 * Hook that fetches and returns a React component for rendering the argument
 * Plasmic component.  Returns undefined if the component data is still
 * being fetched.
 *
 * @param opts.forceOriginal if you used PlasmicComponentLoader.registerComponent,
 *   then normally usePlasmicComponent will return the registered component.
 *   You can set forceOriginal to true if you want to return the Plasmic-generated
 *   component instead.
 */

function usePlasmicComponent(spec, opts) {
  if (opts === void 0) {
    opts = {};
  }

  var rootContext = usePlasmicRootContext();

  if (!rootContext) {
    throw new Error("You can only use usePlasmicComponent if wrapped in <PlasmicRootProvider />");
  }

  var loader = rootContext.loader;
  var lookup = loader.getLookup();
  var component = lookup.hasComponent(spec) ? lookup.getComponent(spec, opts) : undefined;
  var stableSpec = useStableLookupSpec(spec);
  var isMounted = useIsMounted();
  var forceUpdate = useForceUpdate();
  useEffect(function () {
    if (!component) {
      _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee() {
        return runtime_1.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return loader.fetchComponentData(stableSpec);

              case 2:
                if (isMounted()) {
                  forceUpdate();
                }

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }, [component, stableSpec]);
  return component;
}

var _excluded = ["loader", "globalContextsProps", "variation"];
var PlasmicComponentContext = /*#__PURE__*/createContext(false);
function PlasmicComponent(props) {
  var component = props.component,
      projectId = props.projectId,
      componentProps = props.componentProps,
      forceOriginal = props.forceOriginal;
  var rootContext = usePlasmicRootContext();
  var isRootLoader = !useContext(PlasmicComponentContext);

  if (!rootContext) {
    // no existing PlasmicRootProvider
    throw new Error("You must use <PlasmicRootProvider/> at the root of your app");
  }

  var loader = rootContext.loader,
      globalContextsProps = rootContext.globalContextsProps,
      variation = rootContext.variation,
      rest = _objectWithoutPropertiesLoose(rootContext, _excluded);

  var Component = usePlasmicComponent({
    name: component,
    projectId: projectId,
    isCode: false
  }, {
    forceOriginal: forceOriginal
  });
  useEffect(function () {
    if (isRootLoader) {
      var meta = loader.getLookup().getComponentMeta({
        name: component,
        projectId: projectId
      });

      if (meta) {
        loader.trackRender({
          renderCtx: {
            rootProjectId: meta.projectId,
            rootComponentId: meta.id,
            rootComponentName: component,
            teamIds: loader.getTeamIds(),
            projectIds: loader.getProjectIds()
          },
          variation: variation
        });
      }
    }
  }, [component, projectId, loader, variation]);
  var element = useMemo(function () {
    if (!Component) {
      return null;
    }

    var element = createElement(Component, Object.assign({}, componentProps));

    if (isRootLoader) {
      // If this is the root PlasmicComponent, then wrap the content with the
      // react-web's PlasmicRootProvider.  We are doing this here, instead of
      // say PlasmicRootProvider, because we don't have access to this context
      // provider until data has been loaded.  If we insert this provider into
      // the tree at the root after data is loaded, then we'll invalidate the
      // React tree and tree state, which is bad.  Instead, we do it at the
      // "root-most PlasmicComponent"; we won't risk invalidating the sub-tree
      // here because there were no children before the data came in.
      var lookup = loader.getLookup();
      var ReactWebRootProvider = lookup.getRootProvider();
      var GlobalContextsProvider = lookup.getGlobalContextsProvider({
        name: component,
        projectId: projectId
      });
      element = createElement(ReactWebRootProvider, Object.assign({}, rest), createElement(MaybeWrap, {
        cond: !!GlobalContextsProvider,
        wrapper: function wrapper(children) {
          return createElement(GlobalContextsProvider, Object.assign({}, globalContextsProps), children);
        }
      }, createElement(PlasmicComponentContext.Provider, {
        value: true
      }, element)));
    }

    return element;
  }, [Component, componentProps, loader, isRootLoader, component, projectId, globalContextsProps]);
  return element;
}

function MaybeWrap(props) {
  return props.cond ? props.wrapper(props.children) : props.children;
}

/**
 * Performs a prepass over Plasmic content, kicking off the necessary
 * data fetches, and populating the fetched data into a cache.  This
 * cache can be passed as prefetchedQueryData into PlasmicRootProvider.
 *
 * To limit rendering errors that can occur when you do this, we recommend
 * that you pass in _only_ the PlasmicComponents that you are planning to use
 * as the argument.  For example:
 *
 *   const cache = await extractPlasmicQueryData(
 *     <PlasmicRootProvider loader={PLASMIC} prefetchedData={plasmicData}>
 *       <PlasmicComponent component="Home" componentProps={{
 *         // Specify the component prop overrides you are planning to use
 *         // to render the page, as they may change what data is fetched.
 *         ...
 *       }} />
 *       <PlasmicComponent component="NavBar" componentProps={{
 *         ...
 *       }} />
 *       ...
 *     </PlasmicRootProvider>
 *   );
 *
 * If your PlasmicComponent will be wrapping components that require special
 * context set up, you should also wrap the element above with those context
 * providers.
 *
 * You should avoid passing in elements that are not related to Plasmic, as any
 * rendering errors from those elements during the prepass may result in data
 * not being populated in the cache.
 *
 * @param element a React element containing instances of PlasmicComponent.
 *   Will attempt to satisfy all data needs from usePlasmicDataQuery()
 *   in this element tree.
 * @returns an object mapping query key to fetched data
 */

function extractPlasmicQueryData(_x) {
  return _extractPlasmicQueryData.apply(this, arguments);
}
/**
 * Runs react-ssr-prepass on `element`, while isolating rendering errors
 * as much as possible for each PlasmicComponent instance.
 */

function _extractPlasmicQueryData() {
  _extractPlasmicQueryData = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(element) {
    var cache, queryCache;
    return runtime_1.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            cache = new Map();
            _context.prev = 1;
            _context.next = 4;
            return plasmicPrepass(React__default.createElement(PlasmicPrepassContext, {
              cache: cache
            }, element));

          case 4:
            _context.next = 9;
            break;

          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](1);
            console.warn("PLASMIC: Error encountered while pre-rendering", _context.t0);

          case 9:
            queryCache = Object.fromEntries(Array.from(cache.entries()).filter(function (_ref3) {
              var key = _ref3[0],
                  val = _ref3[1];
              return !key.startsWith('$swr$') && val !== undefined;
            }));
            _context.prev = 10;
            return _context.abrupt("return", JSON.parse(JSON.stringify(queryCache, function (key, value) {
              return value !== undefined ? value : null;
            })));

          case 14:
            _context.prev = 14;
            _context.t1 = _context["catch"](10);
            return _context.abrupt("return", queryCache);

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 6], [10, 14]]);
  }));
  return _extractPlasmicQueryData.apply(this, arguments);
}

function plasmicPrepass(_x2) {
  return _plasmicPrepass.apply(this, arguments);
}
/**
 * Returns a clone of the element tree, where componentProps of PlasmicComponent
 * has been processed such that any React elements found are wrapped in
 * an error boundary. Makes it possible to isolate rendering errors while still
 * finishing as much data fetched as possible.
 */

function _plasmicPrepass() {
  _plasmicPrepass = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee2(element) {
    return runtime_1.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return prepass(buildPlasmicPrepassElement(element));

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _plasmicPrepass.apply(this, arguments);
}

function buildPlasmicPrepassElement(element) {
  return React__default.createElement(GenericErrorBoundary, null, processReactElement(element));
}

function processReactElement(element) {
  if (element.type === PlasmicComponent) {
    return React__default.cloneElement(element, processPlasmicComponentProps(element.props));
  } else {
    return React__default.cloneElement(element, processComponentProps(element.props));
  }
}

function processComponentProps(props) {
  if (!props || typeof props !== 'object') {
    return props;
  }

  return Object.fromEntries(Object.entries(props).map(function (_ref) {
    var k = _ref[0],
        v = _ref[1];
    return [k, React__default.isValidElement(v) ? processReactElement(v) : v];
  }));
}

var GenericErrorBoundary = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(GenericErrorBoundary, _React$Component);

  function GenericErrorBoundary(props) {
    return _React$Component.call(this, props) || this;
  }

  var _proto = GenericErrorBoundary.prototype;

  _proto.componentDidCatch = function componentDidCatch(error) {
    console.log("Plasmic: Encountered error while prepass rendering:", error);
  };

  _proto.render = function render() {
    return React__default.createElement(React__default.Fragment, null, this.props.children);
  };

  return GenericErrorBoundary;
}(React__default.Component);
/**
 * To process the componentProps passed to PlasmicComponent, wrap any
 * React element we find in <GenericErrorBoundary />.
 */


function processPlasmicComponentProps(x) {
  if (!x) {
    return x;
  } else if (isFragment(x)) {
    return React__default.createElement(React__default.Fragment, null, React__default.Children.map(x.props.children, processPlasmicComponentProps));
  } else if (React__default.isValidElement(x)) {
    return React__default.createElement(GenericErrorBoundary, null, x);
  } else if (Array.isArray(x)) {
    return x.map(processPlasmicComponentProps);
  } else if (isLiteralObject(x)) {
    return Object.fromEntries(Object.entries(x).map(function (_ref2) {
      var key = _ref2[0],
          val = _ref2[1];
      return [key, processPlasmicComponentProps(val)];
    }));
  } else {
    return x;
  }
}

function isLiteralObject(obj) {
  return !!obj && typeof obj === 'object' && obj.constructor === Object;
}

function renderToElement(_x, _x2, _x3, _x4) {
  return _renderToElement.apply(this, arguments);
}

function _renderToElement() {
  _renderToElement = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(loader, target, lookup, opts) {
    return runtime_1.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (opts === void 0) {
              opts = {};
            }

            return _context.abrupt("return", new Promise(function (resolve) {
              var element = makeElement(loader, lookup, opts);
              ReactDOM.render(element, target, function () {
                return resolve();
              });
            }));

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _renderToElement.apply(this, arguments);
}

function renderToString(loader, lookup, opts) {
  if (opts === void 0) {
    opts = {};
  }

  var element = makeElement(loader, lookup, opts);
  return ReactDOMServer.renderToString(element);
}
function extractPlasmicQueryDataFromElement(_x5, _x6, _x7) {
  return _extractPlasmicQueryDataFromElement.apply(this, arguments);
}

function _extractPlasmicQueryDataFromElement() {
  _extractPlasmicQueryDataFromElement = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee2(loader, lookup, opts) {
    var element;
    return runtime_1.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (opts === void 0) {
              opts = {};
            }

            element = makeElement(loader, lookup, opts);
            return _context2.abrupt("return", extractPlasmicQueryData(element));

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _extractPlasmicQueryDataFromElement.apply(this, arguments);
}

function hydrateFromElement(_x8, _x9, _x10, _x11) {
  return _hydrateFromElement.apply(this, arguments);
}

function _hydrateFromElement() {
  _hydrateFromElement = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee3(loader, target, lookup, opts) {
    return runtime_1.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (opts === void 0) {
              opts = {};
            }

            return _context3.abrupt("return", new Promise(function (resolve) {
              var element = makeElement(loader, lookup, opts);
              ReactDOM.hydrate(element, target, function () {
                return resolve();
              });
            }));

          case 2:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _hydrateFromElement.apply(this, arguments);
}

function makeElement(loader, lookup, opts) {
  if (opts === void 0) {
    opts = {};
  }

  return React__default.createElement(PlasmicRootProvider, {
    loader: loader,
    prefetchedData: opts.prefetchedData,
    globalVariants: opts.globalVariants,
    prefetchedQueryData: opts.prefetchedQueryData
  }, React__default.createElement(PlasmicComponent, {
    component: typeof lookup === 'string' ? lookup : lookup.name,
    projectId: typeof lookup === 'string' ? undefined : lookup.projectId,
    componentProps: opts.componentProps
  }));
}

export { InternalPlasmicComponentLoader, PlasmicComponent, PlasmicComponentLoader, PlasmicRootProvider, convertBundlesToComponentRenderData, extractPlasmicQueryData, extractPlasmicQueryDataFromElement, hydrateFromElement, initPlasmicLoader, matchesPagePath, plasmicPrepass, renderToElement, renderToString, usePlasmicComponent };
//# sourceMappingURL=loader-react.esm.js.map
